import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App';
import './styles/index.css';

// Polyfill for Node.js modules in browser
import { Buffer } from 'buffer';
window.Buffer = Buffer;

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
